import { Field } from '@approvalmax/ui';
import styled from 'styled-components';

export const StyledField = styled(Field)`
    width: 267px;
    min-width: 267px;
    margin-bottom: 22px;
    margin-right: 30px;
`;

export const FieldsWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
`;

export const CurrencyField = styled(Field)`
    width: 267px;
    min-width: 267px;
`;
